import { render, staticRenderFns } from "./EventDate.vue?vue&type=template&id=5c93308c&scoped=true&"
import script from "./EventDate.vue?vue&type=script&lang=js&"
export * from "./EventDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c93308c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c93308c')) {
      api.createRecord('5c93308c', component.options)
    } else {
      api.reload('5c93308c', component.options)
    }
    module.hot.accept("./EventDate.vue?vue&type=template&id=5c93308c&scoped=true&", function () {
      api.rerender('5c93308c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/projects/events/EventDate.vue"
export default component.exports